import { render, staticRenderFns } from "./Brush.vue?vue&type=template&id=2f7804d8&"
import script from "./Brush.vue?vue&type=script&lang=js&"
export * from "./Brush.vue?vue&type=script&lang=js&"
import style0 from "./Brush.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports